import { jwtDecode } from 'jwt-decode';

/**
 * Decodes a JWT token and returns its payload
 * @param {string} token - The JWT token to decode
 * @returns {Object} The decoded token payload
 */
export const decodeToken = (token) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error('Failed to decode token:', error);
    return null;
  }
};

/**
 * Checks if a token is expired
 * @param {string} token - The JWT token to check
 * @returns {boolean} True if the token is expired, false otherwise
 */
export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    
    return decoded.exp < currentTime;
  } catch (error) {
    console.error('Error checking token expiration:', error);
    return true;
  }
};

/**
 * Extracts user information from a token
 * @param {string} token - The JWT token
 * @returns {Object} User information extracted from the token
 */
export const getUserFromToken = (token) => {
  if (!token) return null;
  
  try {
    const decoded = jwtDecode(token);
    
    return {
      username: decoded.username || decoded.name,
      email: decoded.email,
      roles: decoded.role || decoded.roles || [],
      // Add any other user properties from the token
    };
  } catch (error) {
    console.error('Error extracting user from token:', error);
    return null;
  }
};
